import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";

export default function TermsScreen() {
  const navigate = useNavigate();

  const styles = useMemo(() => ({
    page: {
      minHeight: "100vh",
      background: "#ffffff",
      padding: "24px 16px",
      color: "#111",
    },

    container: {
      maxWidth: 900,
      margin: "0 auto",
    },

    title: {
      fontSize: 40,
      fontWeight: 900,
      marginBottom: 8,
    },

    updated: {
      fontSize: 14,
      color: "#666",
      marginBottom: 24,
    },

    p: {
      fontSize: 18,
      lineHeight: 1.9,
      marginBottom: 18,
      color: "#222",
    },

    h: {
      fontSize: 24,
      fontWeight: 800,
      marginTop: 32,
      marginBottom: 12,
      color: "#000",
    },

    ul: {
      paddingLeft: 22,
      marginBottom: 18,
      fontSize: 18,
      lineHeight: 1.9,
      color: "#222",
    },

    back: {
      marginTop: 40,
      padding: "14px 18px",
      fontSize: 16,
      fontWeight: 700,
      borderRadius: 10,
      border: "1px solid #ddd",
      background: "#f5f5f5",
      cursor: "pointer",
    },
  }), []);

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>Terms & Conditions</h1>
        <div style={styles.updated}>Last updated: Jan 28, 2026</div>

        <p style={styles.p}>
          These Terms & Conditions govern your use of <b>Lirivelle</b>. Lirivelle is a platform that
          allows sellers to create independent shops and sell goods or services directly to buyers.
        </p>

        <div style={styles.h}>1. Platform role</div>
        <p style={styles.p}>
          Lirivelle provides the technology for sellers and buyers to connect. Lirivelle does not own,
          inspect, store, or deliver any goods or services listed on the platform.
        </p>

        <div style={styles.h}>2. Seller responsibilities</div>
        <ul style={styles.ul}>
          <li>You own or have the legal right to sell the items or services you list.</li>
          <li>Your listings must be accurate and not misleading.</li>
          <li>You are responsible for delivery, refunds, and communication.</li>
          <li>You must comply with all applicable local laws.</li>
        </ul>

        <div style={styles.h}>3. Buyer responsibilities</div>
        <ul style={styles.ul}>
          <li>Review listings carefully before making payment.</li>
          <li>Communicate respectfully with sellers.</li>
          <li>Understand that payments are made directly to sellers.</li>
        </ul>

        <div style={styles.h}>4. Payments & disputes</div>
        <p style={styles.p}>
          All transactions occur directly between buyers and sellers. Lirivelle is not a party to
          transactions and does not guarantee delivery, quality, or refunds.
        </p>

        <div style={styles.h}>5. Prohibited activity</div>
        <ul style={styles.ul}>
          <li>Fraud, scams, or false payment claims.</li>
          <li>Illegal goods or services.</li>
          <li>Harassment or abuse of other users.</li>
          <li>Attempts to bypass platform security.</li>
        </ul>

        <div style={styles.h}>6. Account actions</div>
        <p style={styles.p}>
          Lirivelle may suspend or remove accounts or listings that violate these Terms or pose a risk
          to users or the platform.
        </p>

        <div style={styles.h}>7. Disclaimer</div>
        <p style={styles.p}>
          The platform is provided “as is.” Lirivelle makes no guarantees regarding uptime, delivery,
          or transaction outcomes.
        </p>

        <div style={styles.h}>8. Changes to these terms</div>
        <p style={styles.p}>
          We may update these Terms at any time. Continued use of the platform indicates acceptance
          of the updated Terms.
        </p>

        <button style={styles.back} onClick={() => navigate(-1)}>
          ← Back
        </button>
      </div>
    </div>
  );
}
